import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import useAuthRequest from '../services/requests.service';

// Hook pour récupérer les offres d'une entreprise
export const useCompanyDeals = (companyId, showPast = false) => {
  const request = useAuthRequest();

  return useQuery({
    queryKey: ['companyDeals', companyId, showPast],
    // isAdmin=true pour que l'entreprise voie aussi ses offres désactivées et puisse les réactiver
    queryFn: () => request.getDataAPI(`/dealsByCompany/${companyId}?showPast=${showPast}&isAdmin=true`),
    enabled: !!companyId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

// Hook pour créer une offre
export const useCreateDeal = () => {
  const request = useAuthRequest();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (dealData) => request.postDataAPI('/deal', dealData),
    onSuccess: (data, variables) => {
      // Invalider les requêtes d'offres
      queryClient.invalidateQueries(['companyDeals']);
      queryClient.invalidateQueries(['allDeals']);
    },
  });
};

// Hook pour supprimer une offre
export const useDeleteDeal = () => {
  const request = useAuthRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dealId) => request.deleteDataAPI(`/deal/${dealId}`),
    onSuccess: () => {
      queryClient.invalidateQueries(['companyDeals']);
      queryClient.invalidateQueries(['allDeals']);
    },
  });
};

// Hook pour activer/désactiver une offre
export const useToggleDealActive = () => {
  const request = useAuthRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ dealId, active }) => request.patchDataAPI(`/deal/${dealId}`, { active }),
    onSuccess: () => {
      queryClient.invalidateQueries(['companyDeals']);
      queryClient.invalidateQueries(['allDeals']);
      queryClient.invalidateQueries(['dealsAll']);
    },
  });
};